module.exports = __webpack_public_path__ + "static/media/digitalCV_33.acb0becb.webp";